import { IConversionSource } from '../conversion-source/conversion-source.model';
import httpClient from "../http/http-client";
import { IConversion, IConversionDetail } from './conversion.model';

export default class ConversionService {
  http;

  constructor() {
    this.http = httpClient
  }

  async findConversion(categoryId: string, queryString?: string): Promise<IConversionDetail> {
    return this.http.get(`conversion/${categoryId}/filter${queryString ? queryString : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getConversionByPk(conversionId: string): Promise<IConversion> {
    return this.http.get(`conversion/${conversionId}`).then(response => response.data).catch(err => { throw err; });
  }

  async getConversionsForConversionSource(conversionSourceId: string, year: string): Promise<IConversion[]> {
    return this.http.get(`conversion/${conversionSourceId}/conversions?year=${year}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }

  async getConversionsForConversionSourceWithPagination(conversionSourceId: string, year: string, searchQuery: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IConversion[], conversionSource: IConversionSource }> {
    return this.http.get(`conversion/${conversionSourceId}/conversions?year=${year}&nameIncludes=${searchQuery}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  /** Super-admin: set SECR reporting source for a single conversion row */
  async patchSecrMapping(conversionId: string, body: { secrSourceKey?: string | null; secrSourceMappingStatus?: 'unmapped' | 'suggested' | 'confirmed' }): Promise<IConversion> {
    return this.http.patch(`conversion/${conversionId}/secr-mapping`, body)
      .then(response => response.data)
      .catch(err => {
        throw err;
      });
  }

}